export default __webpack_public_path__ + "static/social-trends-states-ad076047ab752dd2e9cf22e004f5ef7e.png";